import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { cn } from '@/lib/utils'
import { useTranslation } from 'react-i18next'

type SectionCardProps = {
  title?: string
  description?: string
  header?: React.ReactNode
  right?: React.ReactNode
  children: React.ReactNode
  isLoading?: boolean
  subtitle?: React.ReactNode
  noCardTitle?: boolean
  cardClass?: string
  headerClass?: string
  subtitleClass?: string
  onClick?: () => void
  'data-testid'?: string
  'data-department-id'?: string
  'data-product-id'?: string
  titleTestId?: string
}

export function SectionCard({
  title,
  description,
  header,
  right,
  subtitle,
  children,
  isLoading,
  noCardTitle = false,
  cardClass,
  headerClass,
  subtitleClass,
  onClick,
  'data-testid': dataTestId,
  'data-department-id': dataDepartmentId,
  'data-product-id': dataProductId,
  titleTestId,
}: SectionCardProps) {
  const { t } = useTranslation()
  return (
    <Card
      data-testid={dataTestId}
      data-department-id={dataDepartmentId}
      data-product-id={dataProductId}
      className={cn('border-border/50', onClick && 'cursor-pointer', cardClass)}
      onClick={onClick}
    >
      {!noCardTitle && (
        <CardHeader className={cn('pb-3', headerClass)}>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            {header ? (
              <>{header}</>
            ) : (
              <CardTitle data-testid={titleTestId} className="text-sm">
                {title}
              </CardTitle>
            )}

            <div className="flex flex-wrap justify-end gap-2">{right}</div>
          </div>

          {subtitle ? (
            <div className={cn('flex flex-wrap gap-2', subtitleClass)}>{subtitle}</div>
          ) : (
            <CardDescription className="text-xs">{description}</CardDescription>
          )}
        </CardHeader>
      )}
      <CardContent className={noCardTitle ? 'p-4' : ''}>
        {isLoading ? (
          <div className="flex items-center justify-center py-8">
            <div className="text-sm text-muted-foreground">{t('common.loading')}</div>
          </div>
        ) : (
          <>
            {noCardTitle && <div className="text-xs">{title}</div>}

            {children}
          </>
        )}
      </CardContent>
    </Card>
  )
}
